import { Component, HostBinding, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { ICountryModel } from '@fi-shared/fi-contacts/fi-countries-select/country';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { BehaviorSubject } from 'rxjs';
import { FiCustomValidatorPatterns } from '@fi-shared/fi-custom-validator-patterns/fi-custom-validator-patterns';
import { FiCountryHelperService } from '@fi-shared/fi-contacts/fi-countries-select/country-helper.service';

@Component({
    selector: 'fi-vat-number',
    templateUrl: './vat-number.component.html',
    styleUrls: ['./vat-number.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: VatNumberComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: VatNumberComponent,
        },
    ],
    host: { class: 'fi-vat-number' },
    standalone: false,
})
export class VatNumberComponent extends ControlValueAccessorValidatorBase<IVatNumber> implements OnInit {
    @Input() titleResource: string;

    @HostBinding('class.mobile-layout') get isMobileSmall(): boolean {
        return this.detectDevicesService.isMobileSmall();
    }

    countries$ = new BehaviorSubject<ICountryModel[]>([]);
    selectedCountryId: number;
    FiCustomValidatorPatterns = FiCustomValidatorPatterns;
    //private allowedCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL', 'ES', 'EU', 'FI', 'FR', 'GB', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];

    constructor(
        private injector: Injector,
        private countryHelperService: FiCountryHelperService,
        private detectDevicesService: DetectDevicesService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.setCountriesListData();
    }

    private setCountriesListData() {
        this.countryHelperService.getCountryCodes().then((data: ICountryModel[]) => {
            this.selectedCountryId = data.find((country) => country.IsoTwoCode === this.ngModel.CountryCode)?.Id;
            /*
            const newDataSet = data/!*.filter(item => this.allowedCountries.indexOf(item.IsoCode) >= 0)*!/
                .map((item: CountryModel) => {
                    item.IsoOrder = item.IsoCode;
                    return item;
                });
*/

            this.countries$.next(data);
        });
    }

    onCountryIdChanged(countryId: number) {
        this.ngModel.CountryCode = this.countries$.value.find((country) => country.Id === countryId)?.IsoTwoCode;
        this.doPropagateChanges();
    }

    isNumberRequired(): boolean {
        return !!this.ngModel.CountryCode;
    }

    isCountryCodeRequired(): boolean {
        return !!this.ngModel.Number;
    }
}
